define('collections/product_info_schemas',['require','collections/base','models/product_info'],function(require){

    var BaseCollection = require('collections/base');
    var Model = require("models/product_info");

    return BaseCollection.extend({
        model: Model,
        url: 'product-info.json',
        parse: function(response) {
            return response.results;
          }
    });
});
